
define('text!templates/intro.html',[],function () { return '';});

